import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const InspirationDetailAPI = (slug) => {
  return axios.get(
    `${env.HOST}/inspirasi-terkini/artikel/${slug}`,
    {
      headers
    }
  );
};
export default InspirationDetailAPI;
